var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-loading",style:({ height: _vm.maxHeight })},[_c('div',{staticClass:"infinite-loading__list-group"},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }